<div class="header-buttons">
  <button class="square-btn btn-clear" (click)="onBackButtonClick()">
    <i class="material-icons chevron-icon">arrow_back</i>
  </button>
  <button class="square-btn btn-clear full-screen-button" (click)="onFullScreenClick()">
    <i class="material-icons chevron-icon">{{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}</i>
  </button>
</div>
<h4 class="chatbot-name">{{ chatbotName }}</h4>
<button class="btn btn-md" [ngClass]="tenantConfigService.isHeron ? 'button-primary' : 'button-grey'"
        (click)="onNewChatClick()">
  <i class="material-icons chevron-icon">add</i><span>New chat</span>
</button>
